export const langUa = {
    translation: {
        navbar: {
            mojeKursy: "мої курси"
        }
    }
}